import { render } from "./payment_settings.vue?vue&type=template&id=76862cfa"
import script from "./payment_settings.vue?vue&type=script&lang=js"
export * from "./payment_settings.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__